import { gql } from '@apollo/client'

const BASE_AI_TEST_FIELDS = gql`
  fragment BaseAITestFields on AiTestType {
    id
    title
    isLive
    order
    membershipLevel
    type
    responseType
    casperFullLengthTest {
      id
    }
  }
`

export const FIND_ALL_AI_TEST = gql`
  ${BASE_AI_TEST_FIELDS}

  query findAllAiTest($query: AiTestQueryInput!) {
    findAllAiTest(query: $query) {
      items {
        ...BaseAITestFields
        questions {
          id
          order
          isLive
        }
      }
    }
  }
`

export const FIND_ALL_AI_TEST_FOR_CMS = gql`
  query findAllAiTestForCms($responseType: AITestResponseTypeEnum, $type: AITestTypeEnum!) {
    findAllAiTestForCms(responseType: $responseType, type: $type) {
      gptGrades
      isLive
      order
      question
      questionId
      testId
      testQuestionTitle
      trainingGrades
    }
  }
`

export const FIND_ONE_AI_TEST = gql`
  ${BASE_AI_TEST_FIELDS}

  query findOneAiTest($id: String!) {
    findOneAiTest(id: $id) {
      ...BaseAITestFields
      description
      contextVideoUrl
      contextText
      videoText
      questions {
        id
        title
        questionText
        order
        bestResponseText
        bestResponseVideoUrl
        isLive
      }
    }
  }
`

export const CREATE_AI_TEST = gql`
  ${BASE_AI_TEST_FIELDS}

  mutation createAiTest($input: CreateAiTestInput!) {
    createAiTest(createAiTestInput: $input) {
      ...BaseAITestFields
    }
  }
`

export const UPDATE_AI_TEST = gql`
  ${BASE_AI_TEST_FIELDS}

  mutation updateAiTest($input: UpdateAiTestInput!) {
    updateAiTest(updateAiTestInputFieldName: $input) {
      ...BaseAITestFields
    }
  }
`

export const UPDATE_AI_TEST_QUESTION = gql`
  mutation UpdateAiTestQuestion($input: UpdateAiTestQuestionInput!) {
    updateAiTestQuestion(updateAiTestQuestionInputFieldName: $input) {
      id
    }
  }
`

export const BULK_UPDATE_AI_TEST = gql`
  mutation bulkUpdateAiTest($input: [BulkUpdateAiTestInput!]!) {
    bulkUpdateAiTest(bulkUpdateAiTestInput: $input) {
      id
      order
    }
  }
`

export const FIND_ONE_AI_FLT = gql`
  ${BASE_AI_TEST_FIELDS}

  query findOneAiFullLengthTest {
    findOneCasperFullLengthTest {
      id
      title
      description
      membershipLevel
      aiTests {
        ...BaseAITestFields
      }
    }
  }
`

export const UPDATE_AI_FLT = gql`
  mutation updateAiFullLengthTest($input: UpdateCasperFullLengthTestInput!) {
    updateCasperFullLengthTest(updateCasperFullLengthTestInputFieldName: $input) {
      id
      title
      description
      membershipLevel
    }
  }
`
